import React, { useRef, useState } from 'react'
import { Upload } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
import { add_product_api } from '../api/api';
import { PlusOutlined } from '@ant-design/icons';

function AddProduct() {
    const product_name_ref = useRef(null);
    const [fileListIns, setFileListIns] = useState([]);
    const [fileListIns2, setFileListIns2] = useState([]);
    const [inputValue, setInputValue] = useState({
        item_name: "",
        item_price: "",
        item_description: "",
        thumbnail_image: "",
    });


    // change handle
    const change_handle = (e) => {
        const { name, value, files } = e.target;
        setInputValue({
            ...inputValue,
            [name]: files && files.length > 0 ? files[0] : value,
        });
    };


    // add product api calling
    const add_product_api_call = async () => {
        const formData = new FormData();
        formData.append("item_name", inputValue.item_name);
        formData.append("item_price", inputValue.item_price);
        formData.append("item_description", inputValue.item_description);

        if (inputValue.thumbnail_image) {
            formData.append("thumbnail_image", inputValue.thumbnail_image);
        }
        fileListIns2.forEach((file, index) => {
            formData.append(`image_${index}`, file.originFileObj);
        });

        try {
            const res = await add_product_api(formData);
            if (res.status === 200) {
                // Reset form inputs and file lists
                setInputValue({
                    item_name: "",
                    item_price: "",
                    item_description: "",
                    thumbnail_image: "",
                });
                setFileListIns([]);
                setFileListIns2([]);

                // Focus on the first input
                if (product_name_ref.current) {
                    product_name_ref.current.focus();
                }

                console.log(res.data);
            }
        } catch (error) {
            console.error("Add Product Error", error);
        }
    };


    // apload button
    const uploadButton = (
        <button style={{ border: 0, background: "none" }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );


    // thumbnail before upload 
    const thumb_Before_upload = (file) => {
        const isImage = file.type.startsWith("image/");
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isImage || !isLt3M) {
            file.status = "error";
            return Upload.LIST_IGNORE;
        }
        file.url = URL.createObjectURL(file);
        setInputValue({
            ...inputValue,
            thumbnail_image: file,
        });
        setFileListIns([file]);
        return false;
    };


    // product images before upload
    const images_Before_upload = (file) => {
        const isImage = file.type.startsWith("image/");
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isImage || !isLt3M) {
            file.status = "error";
            return Upload.LIST_IGNORE;
        }
        file.url = URL.createObjectURL(file);
        return false;
    };


    // change handle thumbnail 
    const onChangeIns = ({ fileList }) => {
        setFileListIns(fileList);
    };


    // change handle images
    const onChangeIns2 = ({ fileList }) => {
        setFileListIns2(fileList);
    };

    return (
        <form className="container-fluid" autoComplete="off">
            <div className="row">
                <div className="col-md-12">
                    <div className="card card-primary">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="inputName">Product Name</label>
                                        <input
                                            type="text"
                                            id="inputName"
                                            className="form-control"
                                            placeholder="Enter Product Name"
                                            autoFocus
                                            ref={product_name_ref}
                                            name="item_name"
                                            value={inputValue.item_name}
                                            onChange={change_handle}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="inputPrice">Product Price</label>
                                        <input
                                            type="number"
                                            id="inputPrice"
                                            className="form-control"
                                            placeholder="Enter Product Price"
                                            name="item_price"
                                            value={inputValue.item_price}
                                            onChange={change_handle}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="inputDescription">Product Description</label>
                                        <textarea
                                            id="inputDescription"
                                            className="form-control"
                                            rows={4}
                                            placeholder="Enter Product Description"
                                            name="item_description"
                                            value={inputValue.item_description}
                                            onChange={change_handle}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="thumbnail">Project Thumbnail</label>
                                        <Upload
                                            listType="picture-card"
                                            fileList={fileListIns}
                                            onChange={onChangeIns}
                                            beforeUpload={thumb_Before_upload}
                                            accept=".jpg,.png,.jpeg"
                                        >
                                            {fileListIns.length < 1 && uploadButton}
                                        </Upload>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="productImages">Product Images</label>
                                        <Upload
                                            listType="picture-card"
                                            fileList={fileListIns2}
                                            onChange={onChangeIns2}
                                            beforeUpload={images_Before_upload}
                                            accept=".jpg,.png,.jpeg"
                                            maxCount={4}
                                            multiple
                                        >
                                            {fileListIns2.length < 4 && uploadButton}
                                        </Upload>
                                    </div>
                                </div>
                                <div className="col-12 d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className="btn btn-naariyal-green w-25"
                                        onClick={add_product_api_call}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default AddProduct